import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-reporting',
    templateUrl: './reporting.component.html'
})

export class ReportingComponent implements OnInit {
    imageoneReporting: boolean = false;
    pageTitle: string;
    pageDisplay: string;

    constructor(
        private activatedroute: ActivatedRoute,
        private router: Router,
        private lazyLoadService: LazyLoadScriptService
    ) { }

    ngOnInit(): void {
        var applicationName = "reportingappelement";
        
        this.lazyLoadService.loadScript(environment["REPORTINGAPPURL"], applicationName).subscribe(_ => {
            let url = this.router.url;
            if (url == '/arAgingSummary') {
                this.pageTitle = "A/R Aging Summary";
                this.pageDisplay = "arAgingSummary";
            } 
            else if (url == '/newStarts') {
                this.pageTitle = "New Starts Report";
                this.pageDisplay = "newStarts";
            } 
            else if (url == '/cancellation') {
                this.pageTitle = "Cancellations";
                this.pageDisplay = "cancellation";
            }
            else if (url == '/franchiseeStatus') {
                this.pageTitle = "Franchisee Status Reports";
                this.pageDisplay = "franchiseeStatus";
            }
            else if (url == '/invoiceReport') {
                this.pageTitle = "Invoice Report";
                this.pageDisplay = "invoiceReport";
            }
            else if (url == '/invoiceSalesTaxReport') {
                this.pageTitle = "Invoice Sales Tax Report";
                this.pageDisplay = "invoiceSalesTaxReport";
            }
            else if (url == '/invoiceTrackingReport') {
                this.pageTitle = "Invoice Tracking Report";
                this.pageDisplay = "invoiceTrackingReport";
            }
            else if (url == '/franchiseeInvoiceReport') {
                this.pageTitle = "Franchisee Invoice Report";
                this.pageDisplay = "franchiseeInvoiceReport";
            }
            else if (url == '/loginReport') {
                this.pageTitle = "Login Report";
                this.pageDisplay = "loginReport";
            }
            else if (url == '/transfersReport') {
                this.pageTitle = "Transfers Report";
                this.pageDisplay = "transferReport";
            }
            else if (url == '/franchiseePaymentReport') {
                this.pageTitle = "Franchisee Payment Report";
                this.pageDisplay = "franchiseePaymentReport";
            }
            else if (url == '/clientRetentionReport') {
                this.pageTitle = "Client Retention Report";
                this.pageDisplay = "clientRetentionReport";
            }
            else if (url == '/salesCommissionReport') {
                this.pageTitle = "Sales Commission Report";
                this.pageDisplay = "salesCommissionReport";
            }
            else if (url == '/addendumReport') {
                this.pageTitle = "Addendum Report";
                this.pageDisplay = "addendumReport";
            }
            else if (url == '/payrollReport') {
                this.pageTitle = "Payroll Report";
                this.pageDisplay = "payrollReport";
            }
            else if (url == '/paymentHistory') {
                this.pageTitle = "Payment History";
                this.pageDisplay = "paymentHistory";
            }
            else if (url == '/arAgingDetails') {
                this.pageTitle = "A/R Aging Details";
                this.pageDisplay = "arAgingDetails";
            }
            else if (url == '/adminCharges') {
                this.pageTitle = "Admin Charges Report";
                this.pageDisplay = "adminCharges";
            }
            else if (url == '/suppliesItems') {
                this.pageTitle = "Supply Items Report";
                this.pageDisplay = "suppliesItems";
            }
            else if (url == '/notePaymentDetails') {
                this.pageTitle = "Note Payment Report";
                this.pageDisplay = "notePaymentDetails";
            }
            else if (url == '/franchiseeInsurance') {
                this.pageTitle = "Franchisee Insurance Report";
                this.pageDisplay = "franchiseeInsurance";
            }
            else if (url == '/creditMemoReport') {
                this.pageTitle = "Credit Memo Report";
                this.pageDisplay = "creditMemoReport";
            }            
            console.info('Page Display:',this.pageDisplay);
            this.imageoneReporting = true;
        });

    }

    ngOnDestroy(): void {
        this.imageoneReporting = false;
    }
}